import React, { useEffect, useState } from 'react';
import DynamicNFTCard from '../DynamicCard'; // Component for rendering individual NFT cards
import CardPlaceholder from '../../cards/NFTCardPlaceholder'; // Placeholder component for skeleton loading
import { listNFTs } from '../../../hooks/NFTHook'; // API hook to fetch NFT data

function MostLikedCard(props) {
  // State variables
  const [nfts, setNfts] = useState([]); // Stores the fetched NFTs
  const [hasMore, setHasMore] = useState(true); // Determines if there are more NFTs to load
  const [loading, setLoading] = useState(true); // Indicates if data is being fetched

  // Retrieve wallet address and user ID from local storage
  const userWalletAddress = localStorage.getItem('WalletAddress');
  const userIds = localStorage.getItem("userId");

  // Check if the component is being used for the current user or a general view
  const isUser = props?.user ?? false;

  // Fetch most-liked NFTs on component mount
  useEffect(() => {
    fetchMostLikedNFTs();
  }, [props.filter]);

  /**
   * Fetch most-liked NFTs
   * - For user-specific view, fetch NFTs owned by the user sorted by likes.
   * - For general view, fetch globally most-liked NFTs.
   */
  const fetchMostLikedNFTs = async () => {
    try {
      setLoading(true); // Start loading state

      // Define API parameters based on whether the view is user-specific
      // const Params = isUser
      //   ? { page: 1, limit: 4, sortBy: "totalLikes", ownerAddress: userWalletAddress }
      //   : { page: 1, limit: 4, sortBy: "totalLikes" };
      let Params;
      if (props.filter === "all") {
        Params = isUser
          ? { page: 1, limit: 4, sortBy: "totalLikes", ownerAddress: userWalletAddress }
          : { page: 1, limit: 4, sortBy: "totalLikes" };
      }
      else {
        Params = isUser
          ? { page: 1, limit: 4, sortBy: "totalLikes", category: props.category, ownerAddress: userWalletAddress }
          : { page: 1, limit: 4, sortBy: "totalLikes", category: props.category, };

      }
      // Call API to fetch NFT data
      const allNFTResponse = await listNFTs(Params);

      if (allNFTResponse.success) {
        const allNFTs = allNFTResponse.data;

        // Add `isLike` flag to each NFT based on whether the user has liked it
        const AddIsLikeFlag = allNFTs.map(item => {
          const isLike = item.likes.some(like => like.userId === userIds);
          return { ...item, isLike };
        });

        setNfts(AddIsLikeFlag); // Update state with processed NFT data

        if (allNFTs.length === 0) {
          setHasMore(false); // No more NFTs to load
        }
      }
    } catch (error) {
      console.error("Error fetching NFTs:", error);
    } finally {
      setLoading(false); // End loading state
    }
  };

  return (
    <div>
      <div className="row">
        {/* Show skeleton loaders while loading */}
        {loading ? (
          [...Array(4)].map((_, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6 card-hover-effect" key={index}>
              <CardPlaceholder /> {/* Placeholder for loading state */}
            </div>
          ))
        ) : nfts.length > 0 ? (
          // Render fetched NFTs
          nfts.map((val, index) => (
            <div key={index} className="col-lg-3 col-md-4 col-sm-6">
              <DynamicNFTCard
                NFTLink={`/nftdetails/${val.contractAddress}/${val._id}`} // Dynamic link to NFT details
                contractAddress={val.contractAddress}
                currentOwnerPic={val?.currentOwner?.userId?.profilePicture} // Owner's profile picture
                currentOwnerName={val?.currentOwner?.userId?.name} // Owner's name
                currentOwnerLink={val?.currentOwner?.walletAddress !== userWalletAddress ? `/otherProfile/${val?.currentOwner?.walletAddress}` : "/profile"} // Owner profile link
                mediaUrl={val.imageUri} // Media URL (image or video)
                assetType={val.assetType} // Asset type (image or video)
                title={val.title} // NFT title
                price={val.price} // NFT price
                likes={val.totalLikes} // Total likes
                isLiked={val.isLike} // Whether the NFT is liked by the user
                tokenId={val.tokenId} // NFT token ID
                isListed={val.listed} // Whether the NFT is listed for sale
                nftId={val._id} // Unique NFT ID
              />
            </div>
          ))
        ) : (
          // Show message when no NFTs are available
          <h3>No NFTs Available</h3>
        )}
      </div>
    </div>
  );
}

export default MostLikedCard;
